import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface PropTypes {
  children: React.ReactNode;
}
function WarningText(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <p className="font-bold text-center text-white text-2xl">{children}</p>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
export default WarningText;